import api from '@/api/aiLessons';

// Thin wrappers around the api client. Most return the resolved data straight to
// the wizard; getLimits also caches into the store.
const fetchLimits = ({ commit }) => new Promise((resolve, reject) => {
  api.getLimits()
    .then((data) => { commit('SET_LIMITS', data); resolve(data); })
    .catch(reject);
});

// In-flight promises live outside the store (a Promise is not serializable state) so two
// callers asking for the same key in the same tick share one request.
const catalogueInflight = {};

// NEVER rejects. The catalogue is an enhancement: when it fails the wizard must fall back
// to its bundled lists, not surface an error the teacher can do nothing about. Resolves
// the catalogue, or null when it could not be fetched.
const fetchCatalogue = ({ commit, state }, { targetLanguage }) => {
  // Keyed by the target language alone: the roster is per target language, and so are the
  // localized topic/goal names (the backend derives the CORE locale from it, not from
  // Accept-Language). A UI-language switch changes nothing in the response.
  const key = targetLanguage;
  commit('SET_ACTIVE_CATALOGUE_KEY', key);
  if (state.catalogues[key]) return Promise.resolve(state.catalogues[key]);
  if (catalogueInflight[key]) return catalogueInflight[key];
  commit('SET_CATALOGUE_STATUS', { key, status: 'loading' });
  catalogueInflight[key] = api.getCatalogue(targetLanguage)
    .then((data) => {
      commit('SET_CATALOGUE', { key, catalogue: data });
      commit('SET_CATALOGUE_STATUS', { key, status: 'ready' });
      return data;
    })
    .catch((e) => {
      // Matches syncPreview's deliberate console.warn: no toast, no blocked wizard.
      console.warn('[AI-lesson] catalogue fetch failed, falling back to the bundled lists', e && e.message);
      commit('SET_CATALOGUE_STATUS', { key, status: 'error' });
      return null;
    })
    .then((r) => { delete catalogueInflight[key]; return r; });
  return catalogueInflight[key];
};

const extractSourceMeta = (context, body) => api.extract(body);
const generateLesson = (context, body) => api.generate(body);
const crawlUrl = (context, body) => api.crawl(body);
const cleanSourceText = (context, body) => api.cleanSourceText(body);
const getGenerationJob = (context, jobId) => api.getJob(jobId);
const cancelGenerationJob = (context, jobId) => api.cancelJob(jobId);
const getLesson = (context, id) => api.get(id);
const updateSnapshot = (context, { id, content, title }) => api.updateSnapshot(id, content, title);
const regenerateTask = (context, {
  id, taskId, taskType, tasks, readingText
}) => api.regenerateTask(id, taskId, taskType, tasks, readingText);
const editTask = (context, { id, taskId, task }) => api.editTask(id, taskId, task);
const deleteTask = (context, { id, taskId }) => api.deleteTask(id, taskId);
const editConversation = (context, { id, conversation }) => api.editConversation(id, conversation);
const updateMeta = (context, { id, meta }) => api.updateMeta(id, meta);
const saveLesson = (context, id) => api.save(id);
const previewSyncLesson = (context, { id }) => api.previewSync(id);
const discardLesson = (context, { id }) => api.discard(id);
const publishLesson = (context, { id, body }) => api.publish(id, body);
const exportPdf = (context, { id, variant }) => api.exportPdf(id, variant);

export default {
  fetchLimits,
  fetchCatalogue,
  extractSourceMeta,
  generateLesson,
  crawlUrl,
  cleanSourceText,
  getGenerationJob,
  cancelGenerationJob,
  getLesson,
  updateSnapshot,
  regenerateTask,
  editTask,
  deleteTask,
  editConversation,
  updateMeta,
  saveLesson,
  previewSyncLesson,
  discardLesson,
  publishLesson,
  exportPdf
};



// WEBPACK FOOTER //
// ./src/store/modules/aiLesson/actions.js